const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  // Base URL for card images. Falls back to the original site's blob storage so
  // images work in local dev before our own images bucket is seeded. In prod,
  // VITE_IMAGES_URL is injected at build time.
  imagesUrl:
    import.meta.env.VITE_IMAGES_URL ||
    'https://sdmstorage69.blob.core.windows.net/images/Images/Cards',
  // Duel WebSocket API base (wss://…/ws). Empty in local dev (no duel backend).
  wsUrl: import.meta.env.VITE_WS_URL || '',
};

/** Build the full image URL for a card printing's bare image filename. */
export function cardImageUrl(imageFile: string | null | undefined): string | null {
  if (!imageFile) return null;
  return `${config.imagesUrl}/${imageFile}`;
}

export default config;
